import { render } from "./rightUserSideBar.vue?vue&type=template&id=3b2c492e"
import script from "./rightUserSideBar.vue?vue&type=script&lang=js"
export * from "./rightUserSideBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__